var _rect, _rect2, _rect3, _rect4, _path, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCourseSummary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 15,
    width: 8.1,
    height: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 13.1,
    width: 8.1,
    height: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 11.2,
    width: 8.1,
    height: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 17.1,
    width: 8.1,
    height: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0C5.6,0,0,5.6,0,12.5s5.6,12.5,12.5,12.5S25,19.4,25,12.5S19.4,0,12.5,0  C12.5,0,12.5,0,12.5,0z M16.8,17.7v1.5c0,0.8-0.7,1.5-1.5,1.5H7.1c-0.8,0-1.5-0.7-1.5-1.5V8c0-0.8,0.7-1.5,1.5-1.5c0,0,0,0,0,0h8.2  c0.8,0,1.5,0.7,1.5,1.5c0,0,0,0,0,0v1.5V17.7z M18.8,15.8v1.5c0,0.7-0.4,1.3-1.1,1.5V8c0-1.3-1.1-2.4-2.4-2.4H7.6  C7.8,5,8.4,4.5,9.1,4.5h8.2c0.8,0,1.5,0.7,1.5,1.5v1.5l0,0V15.8z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 9.3,
    width: 8.1,
    height: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseSummary);
export default __webpack_public_path__ + "static/media/icon-course-summary.d0fb5726c83507caeb7aed1ea9228898.svg";
export { ForwardRef as ReactComponent };